import React from "react";
import { Grid } from "../../UI/Grid";
import { Typography } from "../../UI/Typography";

interface IProps {
  title: string;
}

export const SettingsOptionWrapper: React.FC<IProps> = (props) => (
  <Grid container spacing={1}>
    <Grid item xs={12}>
      <Typography variant="subtitle1" fontWeight={500}>
        {props.title}
      </Typography>
    </Grid>
    <Grid item xs={12}>
      {props.children}
    </Grid>
  </Grid>
);
